import authService from "../../components/api-authorization/AuthorizeService";

async function getCompanyProfile(p) {
    const token = await authService.getAccessToken();
    const response = await fetch(`/api/companyProfile?p=${p}`, {
        headers: !token ? {} : { Authorization: `Bearer ${token}` }
    });

    if (response.ok) {
        return await response.json();
    }

    // Try to read the exposed Error header first
    const errorHeader = response.headers.get('Error');
    if (errorHeader) {
        throw new Error(errorHeader);
    }

    // Fallback to reading a JSON error body if present
    let errorBody = null;
    try {
        errorBody = await response.json();
    } catch (e) {
        // ignore parse errors
    }

    if (errorBody) {
        const message = errorBody.detail || errorBody.error || errorBody.title || JSON.stringify(errorBody);
        throw new Error(message);
    }

    throw new Error(`Request failed with status ${response.status}`);
}

async function getFeatureFlags() {
    const token = await authService.getAccessToken();
    const response = await fetch(`/api/companyProfile/featureFlags`, {
        headers: !token ? {} : { Authorization: `Bearer ${token}` }
    });
    return await response.json();
}

export default {
    getCompanyProfile,
    getFeatureFlags
};
